import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
const MED_PHARMA_MESSAGES = {
  PAGE_HEADINGS: {
    TITLE: 'Medpharma',
    SUB_TITLE:
      'Metrics on pharmacy spend and the drug types with the highest plan impact.',
  },
  OVERVIEW_CARDS: {
    MEMBERS: 'Cohort Members',
    COST: 'Cohort Cost',
    PMPM: 'Cohort PMPM',
    PEPM: 'Cohort PEPM',
  },
  DRUG_SURGE_CHART: {
    LEGENDS_DATA: [
      {
        label: 'Previous Year',
        color: patientAccessTheme.palette.warning.main,
      },
      {
        label: 'Current Year',
        color: patientAccessTheme.palette.primary[300],
      },
    ],
  },
  DRUG_CATEGORIES_CHART: {
    TITLE: 'Drug categories of Non Cancer',
  },
  NO_DATA: 'We do not see drug usage in this category',
};

export default MED_PHARMA_MESSAGES;
